import get from 'lodash.get';
import { trackEvent, trackEcommerce } from 'dibs-tracking';
import { graphql } from 'react-relay';
import serverVars from 'server-vars';

function getPurchaseStatus(item) {
    return get(item, 'pdpTrackingVpvParams.purchaseStatus');
}

export function fireTrackEcommerce(item) {
    const locale = serverVars.get('locale');
    const name = locale === 'en-US' ? get(item, 'title') : 'n/a';

    trackEcommerce({
        type: 'addToCart',
        products: [
            {
                brand: get(item, 'seller.serviceId'),
                category: get(item, 'browseUrl'),
                categoryCode: get(item, 'categoryCode'),
                dimension76: get(item, 'pdpTrackingVpvParams.priceType'),
                dimension83: get(item, 'contemporaryTrackingString'),
                id: get(item, 'serviceId'),
                name,
                price: get(item, 'pricing.totalAmount.amount'),
            },
        ],
    });
}

export function trackMakeOfferFromEmail({ item, template }) {
    trackEvent({
        category: 'make offer click',
        action: `email make offer button - ${(template || '').toLowerCase()}`,
        label: getPurchaseStatus(item),
    });
}

export function trackMakeOfferClick(item) {
    const hasPrivateOffer = get(item, 'hasPrivateOffer');
    const trackObj = {
        category: 'make offer click',
        action: 'pdp make offer button',
        label: getPurchaseStatus(item),
        additional: { currentOfferType: `${hasPrivateOffer ? 'private' : 'regular'} offer` },
    };
    trackEvent(trackObj);
    fireTrackEcommerce(item);
}

export function trackNetPriceClick(item) {
    trackEvent({
        category: 'request net price',
        action: 'request net price clicked',
        label: getPurchaseStatus(item),
    });
}

export function trackPurchaseClick(item) {
    const eventName = 'purchase click';
    const eventType = 'pdp purchase button';
    trackEvent({
        category: eventName,
        action: eventType,
        label: getPurchaseStatus(item),
    });
    fireTrackEcommerce(item);
}

// eslint-disable-next-line no-unused-expressions
graphql`
    fragment actionButtonsTracking_item on Item {
        serviceId
        pdpTrackingVpvParams(userId: $userId) @include(if: $isClient)
        contemporaryTrackingString
        title
        vertical
        seller {
            serviceId
        }
        pricing {
            totalAmount {
                amount
            }
        }
        categoryCode
        browseUrl
    }
`;
